import { ButtonHTMLAttributes } from "react";
import { ReactComponent as RightChevron } from "shared/assets/Icons/right.svg";

export enum CardNavButtonVariant {
  Primary,
  Secondary,
}

interface CardNavButtonProps extends ButtonHTMLAttributes<HTMLButtonElement> {
  label: string;
  variant?: CardNavButtonVariant;
}

export default function CardNavButton({
  label,
  variant = CardNavButtonVariant.Primary,
  ...props
}: CardNavButtonProps) {
  const baseClasses =
    "shrink-0 flex justify-between items-center gap-2 min-w-0 font-bold";

  let variantClasses;
  let variantIconClasses;

  switch (variant) {
    case CardNavButtonVariant.Primary:
      variantClasses = "w-full text-white bg-brand-purple h-[50px] px-6";
      variantIconClasses = "h-5 w-3"

      break;
    case CardNavButtonVariant.Secondary:
      variantClasses = "text-brand-purple bg-transparent w-auto p-6";
      variantIconClasses = "h-4 w-3";
      break;
  }

  return (
    <button className={`${baseClasses} ${variantClasses}`} {...props}>
      <p>{label}</p>
      <RightChevron className={variantIconClasses} />
    </button>
  );
}

